import React, { ChangeEvent, InputHTMLAttributes } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { WrappedFieldProps } from 'redux-form';

import flagIcon from './flag-icon.png';

import styles from './PhoneNumberField.css';

interface PhoneNumberFieldProps extends WrappedFieldProps {
  readonly type?: InputHTMLAttributes<HTMLInputElement>['type'];
  readonly placeholder?: InputHTMLAttributes<HTMLInputElement>['placeholder'];
  readonly showTextError?: boolean;
  readonly disabled?: boolean;
  readonly errorRegister?: boolean;
  readonly customClassName?: string;
  readonly customErrorClassName?: string;
}

class PhoneNumberField extends React.Component<PhoneNumberFieldProps> {
  render() {
    const {
      input,
      meta,
      type,
      placeholder,
      showTextError,
      disabled,
      errorRegister,
      customClassName,
      customErrorClassName,
    } = this.props;
    const { touched, error } = meta;
    return (
      <div className={styles['field-wrapper']} id="phone-number-field">
        <div className={styles['input-icon']}>
          <img src={flagIcon} className={styles.flag} />
          +62
        </div>
        <input
          {...input}
          type={type}
          placeholder={placeholder}
          className={
            !touched
              ? `form-control ${styles['input-field']} ${customClassName}`
              : error
              ? `form-control ${customErrorClassName} ${styles['input-field']} ${styles['has-error']} ${customClassName}`
              : `form-control ${styles['input-field']} ${customClassName}`
          }
          maxLength={12}
          onChange={this._onChange}
          disabled={disabled}
        />

        {showTextError && (
          <small className={errorRegister ? styles.error : 'error'}>
            {touched ? error : ''}
          </small>
        )}
        {!showTextError && touched && error && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip">{error}</Tooltip>}
          >
            <span
              className={`form-control-feedback glyphicon glyphicon-remove`}
              style={{ pointerEvents: 'auto', cursor: 'pointer' }}
            />
          </OverlayTrigger>
        )}
        {!showTextError && touched && !error && (
          <span className={`form-control-feedback glyphicon glyphicon-ok`} />
        )}
      </div>
    );
  }

  _onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextVal = e.target.value;
    const {
      input: { onChange },
    } = this.props;

    if (
      !Number.isNaN(Number(nextVal)) &&
      nextVal[0] !== '0' &&
      nextVal[0] !== '6' &&
      nextVal[0] !== '+' &&
      nextVal[0] !== '-' &&
      !/\s/g.test(nextVal) &&
      !/\./g.test(nextVal)
    ) {
      onChange(e, nextVal);
    }
  };
}

export default PhoneNumberField;
